import React from "react";
import { SvgClose } from "../componet/Form/style.js";

function Icon() {
  return (
    <SvgClose
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 17.416 17.416"
      cursor="pointer"
    >
      <path
        fill="#f4f2f0"
        stroke="#f4f2f0"
        d="M.455.455a1.554 1.554 0 000 2.2l5.493 5.491-5.493 5.493a1.554 1.554 0 002.2 2.2l5.493-5.493 5.493 5.493a1.554 1.554 0 002.2-2.2l-5.498-5.493 5.493-5.493a1.554 1.554 0 00-2.2-2.2l-5.49 5.495L2.652.455a1.554 1.554 0 00-2.197 0z"
        transform="translate(.5 .5)"
      ></path>
    </SvgClose>
  );
}

export default Icon;
